type IsDeepEqualProps<T> = {
    prev?: T,
    current?: T,
};

export const isDeepEqual = <T>({prev, current}: IsDeepEqualProps<T>): boolean => {
    if (prev && current && Array.isArray(prev) && Array.isArray(current)) {
        if (current.length !== prev.length) {
            return false;
        }

        return !prev.some(prevChild => current.find(
            currentChild => isDeepEqual({prev: prevChild, current: currentChild}),
        ) === undefined);
    }

    if (prev && current && typeof current === 'object' && typeof prev === 'object') {
        if (Object.keys(prev).length !== Object.keys(current).length) {
            return false;
        }

        return !Object.keys(prev).some(key => !isDeepEqual({
            prev: prev[key as keyof T],
            current: current[key as keyof T],
        }));
    }

    return prev === current;
};
